<div class="app-container" vid="8">
    <header vid="9">
        <div class="image-container">
            <img [src]="product.url || 'assets/price_matcher_icon.png'" alt="No image" height="100px" width="100px">
        </div>
        <div class="price-container" vid="10">
            <div class="label-caps" vid="11">{{ product.brand }}</div>
            <div class="display-large" vid="12">{{ product.title }}</div>
        </div>
        <div class="trend-badge" vid="13">
            <div class="label-caps" vid="14">UPC</div>
            <div vid="15">{{ product.upc }}</div>
        </div>
    </header>

    <div class="chart-section" id="chartArea" vid="16">
        <ngx-charts-line-chart *ngIf="graphData.length > 0" [results]="graphData" [xAxis]="true" [yAxis]="true"
            [legend]="true" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxisLabel]="'Date'"
            [yAxisLabel]="'Price ($)'" [animations]="true">

        </ngx-charts-line-chart>

        <div class="chart-cursor" id="cursor" vid="19"></div>
    </div>

    <div class="selector-row" vid="20">
        <div class="selector-item" vid="21" [ngClass]="{'active': params.range.toString() === 'DAY'}"
            (click)="rangeSelection('DAY')">1D</div>
        <div class="selector-item" vid="22" [ngClass]="{'active': params.range.toString() === 'WEEK'}"
            (click)="rangeSelection('WEKK')">1W</div>
        <div class="selector-item active" vid="23" [ngClass]="{'active': params.range.toString() === 'MONTH'}"
            (click)="rangeSelection('MONTH')">1M</div>
        <div class="selector-item" vid="24" [ngClass]="{'active': params.range.toString() === 'YEAR'}"
            (click)="rangeSelection('YEAR')">1Y</div>
        <div class="selector-item" vid="25" [ngClass]="{'active': params.range.toString() === 'ALL'}"
            (click)="rangeSelection('ALL')">ALL</div>
    </div>

    <div class="stats-grid" vid="26">
        <div class="stat-block" vid="27">
            <div class="label-caps" vid="28">Date</div>
            <div class="stat-row" vid="29">
                <div class="data-point" vid="30">{{ latestPrice.created | date }}</div>
            </div>
        </div>
        <div class="stat-block" vid="31">
            <div class="label-caps" vid="32">Highest</div>
            <div class="stat-row" vid="33">
                <div class="data-point" vid="34">{{ latestPrice.highest | currency }}</div>
            </div>
        </div>
        <div class="stat-block" vid="35">
            <div class="label-caps" vid="36">Lowest</div>
            <div class="stat-row" vid="37">
                <div class="data-point" vid="38">{{ latestPrice.lowest | currency }}</div>
            </div>
        </div>
        <div class="stat-block" vid="39">
            <div class="label-caps" vid="40">Competative</div>
            <div class="stat-row" vid="41">
                <div class="data-point" vid="42">{{ latestPrice.competitive | currency }}</div>
            </div>
        </div>
        <div class="stat-block" style="grid-column: span 2;" vid="43">
            <div class="label-caps" vid="44">Description</div>
            <div class="stat-row" style="margin-top: 8px;" vid="45">
                <div style="font-size: 14px; line-height: 1.4; color: var(--fg-muted);" vid="46">
                    Historical aggregate of top-tier performance assets. Adjusted for inflation and sector
                    volatility.
                </div>
            </div>
        </div>
    </div>
</div>

<nav class="bottom-nav" vid="47">
    <a [routerLink]="['/']" class="nav-item active" vid="48">Home</a>
    <a [routerLink]="['/product']" [queryParams]="{ search: product.upc}" class="nav-item" vid="49">Calculator</a>

</nav>